<template>
    <div class="container">
        
    </div>
</template>

<script> 
import { UrlApi } from '@/api/url'
import useAppConfig from '@core/app-config/useAppConfig'
export default {
    components:{

    },
    data(){
        return{
            code:this.$route.params?.code || null,
        }
    },
    mounted(){
        this.getRoute()

    },  
    methods:{
        getRoute(){
            UrlApi.Redirect(this.code).then(res=>{
                window.location.href = res.data
            }).catch(err=>{
                this.$result(null,err)
            })
        }
    },
    computed:{
        
    }
}
</script>
